import { ProvisionedConstants, STAGE } from './constants';

export enum FeatureFlag {
  RdpIntegration = 'rdpIntegration',
  EmbeddedMode = 'embeddedMode',
  OverlaySection = 'overlaySection',
}

const DEFAULT_FLAGS: Record<FeatureFlag, boolean> = {
  [FeatureFlag.RdpIntegration]: false,
  [FeatureFlag.EmbeddedMode]: false,
  [FeatureFlag.OverlaySection]: false,
};

const STAGE_OVERRIDES: Partial<Record<STAGE, Partial<Record<FeatureFlag, boolean>>>> = {
  [STAGE.DEV]: {
    [FeatureFlag.RdpIntegration]: true,
    [FeatureFlag.EmbeddedMode]: true,
    [FeatureFlag.OverlaySection]: true,
  },
  [STAGE.BETA]: {
    [FeatureFlag.RdpIntegration]: true,
    [FeatureFlag.EmbeddedMode]: true,
    [FeatureFlag.OverlaySection]: true,
  },
  [STAGE.GAMMA]: {
    [FeatureFlag.RdpIntegration]: true,
    [FeatureFlag.EmbeddedMode]: true,
    [FeatureFlag.OverlaySection]: true,
  },
  [STAGE.PROD_NA]: {
    [FeatureFlag.RdpIntegration]: true,
    [FeatureFlag.EmbeddedMode]: true,
    [FeatureFlag.OverlaySection]: false,
  },
};

export const isFeatureEnabled = (flag: FeatureFlag): boolean => {
  const stage = ProvisionedConstants.STAGE as STAGE;
  return { ...DEFAULT_FLAGS, ...STAGE_OVERRIDES[stage] }[flag] ?? false;
};
